import { environment } from '../../../environments/environment';

export class ApiSettings {
  static readonly baseUrl = environment.apiBaseUrl;
  static get fullPath(): string {
    return ApiSettings.baseUrl;
  }
}
